import {Injectable} from '@angular/core';
import {Response, Headers, RequestOptions, URLSearchParams, ResponseContentType} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class CompanyService {

  private urlCompanyUser = `${ environment.apiRoot }/company-find/`;

  constructor(private http: HttpAuth) { }

  public getCompanyUser (email: string): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('email', email);

    let options = new RequestOptions({search: params});

    return this.http.get(this.urlCompanyUser, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getCompany (nit: string): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('nit', nit);

    let options = new RequestOptions({search: params});

    return this.http.get(this.urlCompanyUser, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/company.service.ts